import React from 'react';
import {Col, List, Row} from "antd";
import {CommandDto} from "../api";
import CheckStatusCommandModal from "./modal/commands/CheckStatusCommandModal";
import CompareValueCommandModal from "./modal/commands/CompareValueCommandModal";
import NavigateCommandModal from "./modal/commands/NavigateCommandModal";
import ExecuteCommandModal from "./modal/commands/ExecuteCommandModal";
import SaveValueCommandModal from "./modal/commands/SaveValueCommandModal";
import PrefabCommandModal from "./modal/commands/PrefabCommandModal";
import RequestCommandModal from "./modal/commands/RequestCommandModal";
import WaitCommandModal from "./modal/commands/WaitCommandModal";
import DialogCommandModal from "./modal/commands/DialogCommandModal";
import PauseCommandModal from "./modal/commands/PauseCommandModal";
import ImportTestDataCommandModal from "./modal/commands/ImportTestDataCommandModal";
import PauseRecordCommandModal from "./modal/commands/PauseRecordCommandModal";

/**
 * BasicCommandButtonsTab ist ein Tab mit allen möglichen Commands als Button.
 * Über einen Knopfdruck kann ich ein Modal öffnen,
 * um dieses mit Daten zu befüllen und daraus ein Befehl zu erstellen.
 * @param onCommandCardData
 * @constructor
 */

const BasicCommandButtonsTab = ({onCommandCardData}) => {

    const handleCommandCard = (data: CommandDto) => {
        onCommandCardData(data);
    }

    const data = [
        <NavigateCommandModal onCommandCardData={handleCommandCard}/>,
        <CheckStatusCommandModal onCommandCardData={handleCommandCard}/>,
        <ExecuteCommandModal onCommandCardData={handleCommandCard}/>,
        <SaveValueCommandModal onCommandCardData={handleCommandCard}/>,
        <CompareValueCommandModal onCommandCardData={handleCommandCard}/>,
        <PrefabCommandModal onCommandCardData={handleCommandCard}/>,
        <RequestCommandModal onCommandCardData={handleCommandCard}/>,
        <WaitCommandModal onCommandCardData={handleCommandCard}/>,
        <DialogCommandModal onCommandCardData={handleCommandCard}/>,
        <PauseCommandModal onCommandCardData={handleCommandCard}/>,
        <ImportTestDataCommandModal onCommandCardData={handleCommandCard}/>,
        <PauseRecordCommandModal onCommandCardData={handleCommandCard}/>
    ]

    return (
        <Row gutter={[16, 16]}>
            {data.map((item, index) => (
                <Col key={index} xs={24} sm={12} md={12} lg={12} xl={12}>
                    {item}
                </Col>
            ))}
        </Row>
    );
}

export default BasicCommandButtonsTab;